import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { first, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

import { CoreConfigService } from '../../../../@core/services/config.service';
import Stepper from 'bs-stepper';
import * as snippet from '../../../../app/main/elements/radio/radio.snippetcode';
import * as snippetDatePicker from '../../../../app/main/elements/date-time-picker/date-time-picker.snippetcode';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute, Router } from '@angular/router';
import Swal from 'sweetalert2';
import { CommonService } from '../../../auth/service/common.service';
import { AuthenticationService } from '../../../../app/auth/service';
import { ParentParameters, statusCode } from '../../../auth/models/commonEnum';
import { environment } from 'environments/environment';
import * as CryptoJS from 'crypto-js';

@Component({
	selector: 'app-register',
	templateUrl: './register.component.html',
	styleUrls: ['./register.component.scss'],
	encapsulation: ViewEncapsulation.None
})
export class RegisterComponent implements OnInit {
	// Public
	public coreConfig: any;
	public passwordTextType: boolean;
	// public addressForm: FormGroup;
	// public personalInfoForm: FormGroup;
	public accountDetailsForm: FormGroup;

	parameterSettings = [];
	subjectAreaType = [];
	// identityProofType = [];
	// countryData = [];
	// stateData = [];
	// districtData = [];
	// cityData = [];
	public submitted = false;
	public loading = false;
	public returnUrl: string;
	public error = '';

	public contentHeader: object;

	public _snippetCodeRadioCustom = snippet.snippetCodeRadioCustom;
	public _snippetCodeCustomFooterDP = snippetDatePicker.snippetCodeCustomFooterDP;

	// public genderList = [
	//   { genderName: 'Male', genderValue: "M" },
	//   { genderName: 'Female', genderValue: "F" },
	// ];
	public key = environment.cryptoJSKey;
	public iv = environment.cryptoJSIV;
	// private
	private horizontalWizardStepper: Stepper;
	public customFooterDPdata: NgbDateStruct;
	public signupVisible: boolean;
	/**
	 * Horizontal Wizard Stepper Next
	 *
	 * @param data
	 */
	horizontalWizardStepperNext(data) {
		this.submitted = true;
		if (data.status === "VALID") {
			this.submitted = false;
			this.horizontalWizardStepper.next();
		}
	}
	/**
	 * Horizontal Wizard Stepper Previous
	 */
	horizontalWizardStepperPrevious() {
		this.horizontalWizardStepper.previous();
	}


	// Private
	private _unsubscribeAll: Subject<any>;

	/**
	 * Constructor
	 *
	 * @param {CoreConfigService} _coreConfigService
	 * @param {FormBuilder} _formBuilder
	 */
	constructor(private _router: Router,
		private _route: ActivatedRoute,
		private _coreConfigService: CoreConfigService,
		private _formBuilder: FormBuilder,
		private _commonService: CommonService,
		private _authenticationService: AuthenticationService) {
		this._unsubscribeAll = new Subject();

		// Configure the layout
		this._coreConfigService.config = {
			layout: {
				navbar: {
					hidden: true
				},
				menu: {
					hidden: true
				},
				footer: {
					hidden: true
				},
				customizer: false,
				enableLocalStorage: false
			}
		};

		this.accountDetailsForm = this._formBuilder.group({
			FirstName: ["", [Validators.required]],
			LastName: ["", [Validators.required]],
			Email: ["", [Validators.required, Validators.email]],
			Mobile: ["", [Validators.required, Validators.maxLength(10),]],
			Password: ['', [Validators.required]],
			ConfirmPassword: ['', [Validators.required]],
			SubjectArea: [],
			privacyPolicy:['',[Validators.required]]
		});

		// this.personalInfoForm = this._formBuilder.group({
		//   Title: ["", [Validators.required]],
		//   Name: ['', [Validators.required]],
		//   DateOfBirth: ['', [Validators.required]],
		//   Gender: ['M',],
		//   Department: ['', [Validators.required]],
		//   Designation: ['', [Validators.required]],
		//   IdentityProof: ['', [Validators.required]],
		//   Institute: ['', [Validators.required]],
		//   InstituteAddress: ['', [Validators.required]],
		// });

		// this.addressForm = this._formBuilder.group({
		//   Address: ["", [Validators.required]],
		//   Landmark: ["", [Validators.required]],
		//   Country: ["", [Validators.required]],
		//   State: ["", [Validators.required]],
		//   District: ["", [Validators.required]],
		//   City: ["", [Validators.required]],
		//   Pincode: ["", [Validators.required, Validators.maxLength(6)]],
		//   Mobile: ["", [Validators.required, Validators.maxLength(10)]],
		//   Landline: ["", [Validators.required, Validators.maxLength(15)]],
		//   Email: ["", [Validators.required, Validators.email]],
		// });
	}

	ngOnInit(): void {
		this.returnUrl = this._route.snapshot.queryParams['returnUrl'] || '/';
		this.loadSubjectTypeData();
		// this.loadIdentityProofData();
		// this.loadCountryData();
		// this.loadStateData(0);
		// this.loadDistrictData(0);
		// this.loadCityData(0);
		//this.horizontalWizardStepper = new Stepper(document.querySelector('#stepper1'), {});

		// Subscribe to config changes
		this._coreConfigService.config.pipe(takeUntil(this._unsubscribeAll)).subscribe(config => {
			this.coreConfig = config;
		});
		this.signupVisible = true;
	}

	loadSubjectTypeData() {
		this._commonService.getParameterSettings(ParentParameters.SUBJECTAREA).subscribe((result: any) => {
			this.subjectAreaType = [];
			if (result.statusCode == 200) {
				result["data"]["response"].forEach(element => {
					this.subjectAreaType.push({
						label: element.paraDescription,
						value: element.paraId
					});
				});
			}
		});
	}

	// loadIdentityProofData() {
	//   this._commonService.getParameterSettings(ParentParameters.IDENTITY_PROOF).subscribe((result: any) => {
	//     this.identityProofType = [];
	//     this.identityProofType.push({
	//       identityProofTypeName: "Select Identity Proof type",
	//       identityProofTypeID: ""
	//     });
	//     if (result.statusCode == 200) {
	//       result["data"]["response"].forEach(element => {
	//         this.identityProofType.push({
	//           identityProofTypeName: element.paraDescription,
	//           identityProofTypeID: element.paraId
	//         });
	//       });
	//     }
	//   });
	// }

	// loadCountryData() {
	//   this._commonService.getCountryData().subscribe((result: any) => {
	//     this.countryData = [];
	//     this.countryData.push({
	//       label: "Select Country",
	//       value: ""
	//     });
	//     if (result.data.response.length > 0) {
	//       result["data"]["response"].forEach(element => {
	//         this.countryData.push({
	//           label: element.name,
	//           value: element.id
	//         });
	//       });
	//     }
	//   });
	// }

	// countryChange(id: number) {
	//   this.stateData = [];
	//   this.districtData = [];
	//   this.cityData = [];
	//   this.loadStateData(id);
	//   this.addressForm.controls['State'].reset();
	//   this.addressForm.controls['District'].reset();
	//   this.addressForm.controls['City'].reset();
	// }

	// loadStateData(countryID: number) {
	//   this._commonService.getStateData(countryID).subscribe((result: any) => {
	//     this.stateData = [];
	//     this.stateData.push({
	//       stateName: "Select State",
	//       stateID: ""
	//     });
	//     if (result.data != undefined && result.data.response.length > 0) {
	//       result["data"]["response"].forEach(element => {
	//         this.stateData.push({
	//           stateName: element.name,
	//           stateID: element.id
	//         });
	//       });
	//     }
	//   });
	// }

	// stateChange(stateID: number) {
	//   this.districtData = [];
	//   this.cityData = [];
	//   this.loadDistrictData(stateID);
	//   this.addressForm.controls['District'].reset();
	//   this.addressForm.controls['City'].reset();
	// }

	// loadDistrictData(stateID: number) {
	//   this._commonService.getDistrictData(stateID).subscribe((result: any) => {
	//     this.districtData = [];
	//     this.districtData.push({
	//       districtName: "Select District",
	//       districtID: ""
	//     });
	//     if (result.data != undefined && result.data.response.length > 0) {
	//       result["data"]["response"].forEach(element => {
	//         this.districtData.push({
	//           districtName: element.districtTitle,
	//           districtID: element.id
	//         });
	//       });
	//     }
	//   });
	// }

	// districtChange(districtID: number) {
	//   this.loadCityData(districtID);
	//   this.addressForm.controls['City'].reset();
	// }

	// loadCityData(districtID: number) {
	//   this._commonService.getCityData(districtID).subscribe((result: any) => {
	//     this.cityData = [];
	//     this.cityData.push({
	//       cityName: "Select City",
	//       cityID: ""
	//     });
	//     if (result.data != undefined && result.data.response.length > 0) {
	//       result["data"]["response"].forEach(element => {
	//         this.cityData.push({
	//           cityName: element.name,
	//           cityID: element.id
	//         });
	//       });
	//     }
	//   });
	// }
	/**
	 * On destroy
	 */
	ngOnDestroy(): void {
		// Unsubscribe from all subscriptions
		this._unsubscribeAll.next();
		this._unsubscribeAll.complete();
	}

	get a() {
		return this.accountDetailsForm.controls;
	}

	// get p() {
	//   return this.personalInfoForm.controls;
	// }

	// get f() {
	//   return this.addressForm.controls;
	// }

	/**
	 * Toggle password
	 */
	togglePasswordTextType() {
		this.passwordTextType = !this.passwordTextType;
	}
	timeLeft: number = 60;
  	interval;
	
	
	mySubmit(){
		this.signupVisible = true;
	}
	/**
	 * On Submit
	 */
	onSubmit() {

		this.submitted = true;
		
		if(this.submitted = true){
			clearInterval(this.interval);
			this.interval = setInterval(() => {
				if(this.timeLeft > 0) {
				  this.timeLeft--;
				} else {
				  this.timeLeft = 60;
				}
			},1000)
		}
		if (this.accountDetailsForm.invalid) {
			return false;
		}
		const encryptedPassword = CryptoJS.HmacSHA256(this.accountDetailsForm.get('Password').value, this.key).toString();
		//let dob = this.personalInfoForm.get('DateOfBirth').value;
		const data = {
			firstName: this.accountDetailsForm.get('FirstName').value,
			lastName: this.accountDetailsForm.get('LastName').value,
			email: this.accountDetailsForm.get('Email').value,
			mobile: this.accountDetailsForm.get('Mobile').value,
			password: encryptedPassword,
			subjectArea: this.selectedIDs,
			// title: this.personalInfoForm.get('Title').value,
			// name: this.personalInfoForm.get('Name').value,
			// dateOfBirth: dob.day + "/" + dob.month + "/" + dob.year,
			// gender: this.personalInfoForm.get('Gender').value,
			// department: this.personalInfoForm.get('Department').value,
			// designation: this.personalInfoForm.get('Designation').value,
			// identityProof: this.personalInfoForm.get('IdentityProof').value,
			// institute: this.personalInfoForm.get('Institute').value,
			// instituteAddress: this.personalInfoForm.get('InstituteAddress').value,
			// customerAddress: this.addressForm.get('Address').value,
			// landmark: this.addressForm.get('Landmark').value,
			// country: this.addressForm.get('Country').value,
			// state: this.addressForm.get('State').value,
			// district: this.addressForm.get('District').value,
			// city: this.addressForm.get('City').value,
			// pincode: this.addressForm.get('Pincode').value,
			// mobile: this.addressForm.get('Mobile').value,
			// landline: this.addressForm.get('Landline').value,
			// email: this.addressForm.get('Email').value,
		}
		// registration
		this.loading = true;
		this._authenticationService
			.registration(data)
			.pipe(first())
			.subscribe(
				result => {
					if(this.accountDetailsForm.valid && Number(result["statusCode"]) === statusCode.SUCCESS){
						this.signupVisible = false;
						setTimeout(this.mySubmit, 5000);
					}
					if (Number(result["statusCode"]) === statusCode.SUCCESS) {
						this.submitted = false;
						Swal.fire({
							icon: 'success',
							title: 'Congratulations!',
							text: 'Your sign-up process is successfully completed, kindly login to proceed further.',
							customClass: {
								confirmButton: 'btn btn-success'
							}
						});
						this._router.navigate(['/login']);
						// this._router.navigate([this.returnUrl]);
					}
					else {
						this.error = result.message;
						this.loading = false;
						
						Swal.fire({
							icon: 'info',
							title: 'Info!',
							text: result["message"],
							customClass: {
								confirmButton: 'btn btn-error'
							}
						});
					}
				},
				error => {
					this.error = error;
					this.loading = false;
					Swal.fire({
						icon: 'error',
						title: 'Error!',
						text: error,
						customClass: {
							confirmButton: 'btn btn-error'
						}
					});
				}
			);

		return false;
	}
	selectedIDs: any = [];
	onCheckboxChange(e){
		if (e.target.checked) {
			this.selectedIDs.push(e.target.value);
		} else {
			const index = this.selectedIDs.findIndex(x=> x == e.target.value);
			if(index >= 0){
				this.selectedIDs.splice(index, 1);
			}
		}
	}
}
